import { Button } from '@creditornot/cb-button';
import { elevationCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type ImportEntryPointProps = {
  onSelectSheetClick: () => void;
  onSelectTemplateClick: () => void;
  isSelectSheetLoading: boolean;
};

const Root = styled.div`
  ${elevationCss(2)}
  display: flex;
  padding: 48px;
  flex-grow: 1;
  border-radius: 8px;
  max-width: 848px;
  flex-direction: column;
  gap: 24px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 24px;
`;

export const ImportEntryPoint = ({
  onSelectSheetClick,
  isSelectSheetLoading,
  onSelectTemplateClick,
}: ImportEntryPointProps) => {
  return (
    <Root>
      <T.Heading6>
        <FormattedMessage id="shared-menu.editor.importer.entrypoint.title" />
      </T.Heading6>
      <T.Body3>
        <FormattedMessage id="shared-menu.editor.importer.entrypoint.body" />
      </T.Body3>
      <ButtonsContainer>
        <Button size="large" variant="blue" onClick={onSelectSheetClick} loading={isSelectSheetLoading}>
          <FormattedMessage id="shared-menu.editor.importer.entrypoint.buttons.select-sheet" />
        </Button>
        <Button size="large" variant="lightBlue" onClick={onSelectTemplateClick}>
          <FormattedMessage id="shared-menu.editor.importer.entrypoint.buttons.export-to-sheet" />
        </Button>
      </ButtonsContainer>
    </Root>
  );
};
